module.exports = __webpack_public_path__ + "static/img/tlb_tx.40a22c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/geren/qietu/tlb_tx.png
// module id = MgUS
// module chunks = 36